var magicStyles = [".image[data-v-ea7096f4],.picture[data-v-ea7096f4]{display:block;width:100%;height:100%}.image[data-v-ea7096f4]{object-fit:cover;object-position:50% 50%}"];

export default magicStyles;
